import PropTypes from 'prop-types';
import classNames from 'classnames';
import success from './icons/outline-check_circle_outline-24px.svg';
import info from './icons/outline-info-24px.svg';
import error from './icons/outline-error_outline-24px.svg';

import './index.less';

const getIconUrl = (status) => {
  if (status === 'success') {
    return success;
  } if (status === 'info') {
    return info;
  } if (status === 'error') {
    return error;
  }

  return null;
};

const UserFeedback = ({ status, children, showIcon = true }) => {
  const url = getIconUrl(status);
  return <div
    className={classNames('userfeedback', `userfeedback--${status}`, { 'hidden-icon': !showIcon })}
  >
    {showIcon && <img src={url} alt={status}/>}
    <div>{children}</div>
  </div>;
};

UserFeedback.propTypes = {
  status: PropTypes.oneOf(['success', 'info', 'warning', 'error']).isRequired,
  children: PropTypes.any.isRequired,
};

export default UserFeedback;
